export default __webpack_public_path__ + "static/media/15.c0174640.jpg";